import { render } from "./AdminCalendarEvents.vue?vue&type=template&id=1577a718&scoped=true"
import script from "./AdminCalendarEvents.vue?vue&type=script&lang=js"
export * from "./AdminCalendarEvents.vue?vue&type=script&lang=js"

import "./AdminCalendarEvents.vue?vue&type=style&index=0&id=1577a718&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1577a718"]])

export default __exports__